<template>
  <div class="scroll-dots">
    <button
      v-for="(dot, index) in total"
      :key="index"
      class="scroll-dots__dot"
      :class="{ active: currentSection === index }"
      :aria-label="`섹션 ${index + 1}로 이동`"
      @click="$emit('navigate', index)"
    />
  </div>
</template>

<script>
export default {
  name: 'ScrollDots',
  props: {
    currentSection: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 5
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables';

.scroll-dots {
  position: fixed;
  right: 28px;
  top: 50%;
  transform: translateY(-50%);
  z-index: $z-scrolldots;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: $bp-mobile) {
    display: none;
  }
}

.scroll-dots__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1.5px solid rgba($color-ivory, 0.5);
  background-color: transparent;
  cursor: pointer;
  transition: all $transition-base;
  padding: 0;

  &:hover {
    border-color: $color-gold;
    background-color: rgba($color-gold, 0.3);
    transform: scale(1.3);
  }

  &.active {
    background-color: $color-gold;
    border-color: $color-gold;
    transform: scale(1.2);
    box-shadow: 0 0 8px rgba($color-gold, 0.5);
  }
}
</style>
